import { render, staticRenderFns } from "./PlatformReceiptsPaymentsStatementsDetail.vue?vue&type=template&id=78ec126d&scoped=true"
import script from "./PlatformReceiptsPaymentsStatementsDetail.vue?vue&type=script&lang=js"
export * from "./PlatformReceiptsPaymentsStatementsDetail.vue?vue&type=script&lang=js"
import style0 from "./PlatformReceiptsPaymentsStatementsDetail.vue?vue&type=style&index=0&id=78ec126d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec126d",
  null
  
)

export default component.exports